import { borderRadius, ButtonGroup } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const StyledButtonGroup = styled.div`
  ${ButtonGroup.Styles.ButtonGroupRoot} {
    ${borderRadius.r2};
    width: 300px;
  }
  ${ButtonGroup.Styles.ButtonGroupItem} {
    padding: 4px 8px;
  }
`;
